const sameText = (a?: string, b?: string) => !!a && !!b && a.toLowerCase() === b.toLowerCase();

// The forms hold a user in shapes that may lack an Id or an AadObjectId, so any one identity that matches is enough.
export const isSameUser = (a: PlatformUser, b: PlatformUser) =>
  !!a && !!b && (
    (Number(a.Id) > 0 && Number(a.Id) === Number(b.Id)) ||
    sameText(a.AadObjectId, b.AadObjectId) ||
    sameText(a.UserName, b.UserName)
  );

export const withoutUsers = (users: PlatformUser[], excluded: PlatformUser[]) =>
  excluded.length === 0 ? users : users.filter((u) => !excluded.some((x) => isSameUser(u, x)));
